/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'gslb-pool';

export const gslbServicePoolModalBreadcrumbTitle = `${prefix}.gslbServicePoolModalBreadcrumbTitle`;
export const gslbServicePoolMemberModalBreadcrumbTitle = `${prefix}.gslbServicePoolMemberModalBreadcrumbTitle`;

export const ENGLISH = {
    [gslbServicePoolModalBreadcrumbTitle]: 'GSLB Pool',
    [gslbServicePoolMemberModalBreadcrumbTitle]: 'Pool Member',
};
